import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const DeleteIcon = ({
  title = 'Delete',
  className = 'delete-icon',
  viewBox = '0 0 16 16',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} className={className} viewBox={viewBox} {...props}>
    <path
      fillRule="evenodd"
      d="M8.473.527c1.027 0 1.87.758 1.941 1.715l.004.125h3.238c.36 0 .649.278.649.617 0 .32-.262.586-.598.61l-.05.004h-.684l-.547 9.468c-.051.938-.836 1.676-1.805 1.739l-.137.004H4.516c-.989 0-1.813-.7-1.93-1.614l-.012-.129-.55-9.468h-.68c-.36 0-.649-.278-.649-.614 0-.324.262-.59.598-.613l.05-.004h3.239c0-.972.8-1.773 1.813-1.836l.132-.004zm3.203 3.07H3.324L3.867 13c.016.281.23.512.512.566l.086.012.05.004h5.97a.638.638 0 00.636-.5l.012-.082zM9.12 5.88c.34 0 .621.25.645.57l.004.043v5.606c0 .34-.293.617-.649.617a.637.637 0 01-.648-.57V6.492c0-.34.289-.613.648-.613zm-3.242 0c.344 0 .621.25.648.57v5.649c0 .34-.289.617-.648.617-.34 0-.621-.25-.645-.57l-.004-.047V6.492c0-.34.293-.613.649-.613zm2.594-4.125H6.527a.636.636 0 00-.64.531l-.008.082H9.12a.625.625 0 00-.52-.601l-.081-.008zm0 0"
    />
  </CreateIconComponent>
);

export default DeleteIcon;
